<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Kaunter : Daftar Kaunter">
            <w-form
                class=""
                v-model="form.valid"
                v-model:errors-count="form.errorsCount"
                @validate="submitDaftarKaunter"
                @success="Success"
            >
                <div class="message-box">
                    <w-transition-fade>
                        <w-alert
                            class="my0 text-light"
                            v-if="form.submitted"
                            success
                            no-border
                        >
                            The form is valid, ready to send it!
                        </w-alert>

                        <w-alert
                            class="my0 text-light"
                            v-else-if="form.valid === false"
                            error
                            no-border
                        >
                            Terdapat {{ form.errorsCount }} ralat di dalam
                            borang ini.
                        </w-alert>
                    </w-transition-fade>
                </div>



                <!-- </w-from> -->
                <w-card bg-color="" class="">
                    <h3>Butiran</h3>
                    <w-flex class="mt3">
                        <div class="xs6">
                            <z-input
                                label="Kod Kaunter  *"
                                v-model="form.kaunter_kod"
                                :validators="[validators.required]"
                            />
                        </div>
                        &nbsp;&nbsp;&nbsp;
                        <div class="xs6">
                            <z-input
                                label="Keterangan *"
                                v-model="form.kaunter_keterangan"
                                :validators="[validators.required]"
                            />
                        </div>
                    </w-flex>

                    <w-flex class="mt3">
                        <div class="xs6">
                        <z-lookup
                            label="Jenis Kaunter *"
                            :url='service_kutipan +"lookup/lkp_kaunter"'
                            :sort="false"
                            :cache="false"
                            v-model="form.lkp_kaunter_id"
                            :validators="[validators.required]"
                        />
                        </div>
                        &nbsp;&nbsp;&nbsp;
                        <div class="xs6">
                            <z-lookup
                            label="Jabatan *"
                            :url="service_kutipan + 'lookup/jabatan_user'"
                            :sort="false"
                            :cache="false"
                            v-model="form.jabatan_id"
                            :validators="[validators.required]"
                        />
                        </div>
                    </w-flex>

                </w-card>
                <w-flex class="mt3" wrap align-center justify-end>
                    <div class="spacer" />
                    <w-button
                        class="mr2"
                        bg-color="warning"
                        type="reset"
                        @click="tutup"
                    >
                        Kembali
                    </w-button>&nbsp;
                    <w-button
                        class="mr2"
                        bg-color="warning"
                        type="reset"
                        @click="clear()"
                    >
                        Reset
                    </w-button>
                            &nbsp;
                    <template v-if="form.kaunter_keterangan != null && form.jabatan_id != null && form.lkp_kaunter_id != null && form.kaunter_kod != null ">
                        <w-button
                            class="my1"
                            type="submit"
                            :disabled="form.valid === false"
                            :loading="form.submitted && !form.sent"
                        >
                            <w-icon dark tile class="mr2">fal fa-save</w-icon>
                            Simpan
                        </w-button>
                    </template>
                    <template v-else>
                        <w-button
                            class="my1"
                            disabled
                        >
                            <w-icon dark tile class="mr2">fal fa-save</w-icon>
                            Simpan
                        </w-button>
                    </template>
                </w-flex>
            </w-form>

        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";
// import moment from 'moment'

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        id: [Array, Object, String],
    },
    data() {
        return {
            resourceurl: this.service_kutipan + "lkp/kaunter/daftar",
            reload: true,

            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan" },
                { label: "Kaunter", route: "/kaunter" },
                { label: "Daftar Kaunter", route: "/Kaunter/daftar" },
            ],

            form: {
                valid: null,
                submitted: false,
                sent: false,
                errorsCount: 0,
            },
            validators: {
                required: (value) => !!value || "Medan Ini Wajib Isi",
            },
        };
    },
    methods: {

        // profil() {
        //     this.dialogProfil.show = 1;
        // },
        clear () {
            this.getData()
            this.files = false
            this.form.kaunter_kod = null
            this.form.kaunter_keterangan = null
            this.form.lkp_kaunter_id = null
            this.form.jabatan_id = null
            this.$nextTick(() => {
                this.files = true
            })
        },

        submitDaftarKaunter() {
            // alert(t)
            if (this.form.valid == true) {
            this.$zcomm
                .post(this.resourceurl, this.form)
                .then((res) => {
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.$zutil.notify("Rekod telah berjaya Daftar");
                    // this.$inertia.visit(this.$route('kaunter.senarai'))
                })
                .catch((err) => {})
                .finally(() => {

                });
            }
        },
    },
    watch: {
        files: function (val) {
            // console.log(val);
            console.log("work");
        },
        "form.lkp_poskod_id": function (q) {
            this.poskodDetail();
        },
        "form_cari.id": function (q) {
            this.jabatanDetail();
            // this.profilDetail();
        },
        "form_akaun.id": function (q) {
            this.akaunDetail();
        },
    },
    mounted() {
        this.dialog.width = 900;
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
